import { render } from "./BaseCardImage.vue?vue&type=template&id=26a161d2"
import script from "./BaseCardImage.vue?vue&type=script&lang=js"
export * from "./BaseCardImage.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__